import { type MediaStreamOptions } from 'store/streaming'

export enum EventsEmitter {
  STOP_ALL_AUDIO_POSTS = 'STOP_ALL_AUDIO_POSTS',
  STOP_ALL_VIDEOS = 'STOP_ALL_VIDEOS',
  LIVE_CHANGE_CAMERA = 'LIVE_CHANGE_CAMERA',
  LIVE_CHANGE_MICROPHONE = 'LIVE_CHANGE_MICROPHONE'
}

interface EventPayloadMap {
  [EventsEmitter.STOP_ALL_AUDIO_POSTS]: undefined

  [EventsEmitter.STOP_ALL_VIDEOS]: {
    instanceId: string
  }

  [EventsEmitter.LIVE_CHANGE_CAMERA]:
    MediaStreamOptions

  [EventsEmitter.LIVE_CHANGE_MICROPHONE]:
    MediaStreamOptions
}

export type EventPayload<
  T extends EventsEmitter
> =
  T extends keyof EventPayloadMap
    ? EventPayloadMap[T]
    : never